/**
 * @module isDevEnvironment
 */

import { isGulpOrBranchingValue } from 'owa-querystring';
import { isTdsBox } from 'owa-config';

/**
 * @function
 * To check whether the environment is development or not
 * @returns A whether the environment is development or not
 */

const isDevEnvironment = (): boolean => {
    return isGulpOrBranchingValue || isTdsBox();
};

export default isDevEnvironment;
